import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import ArchiveNews from '../views/news/Archive.vue';
import SingleNews from '../views/news/Single.vue';
import Concept from '../views/concept/Index.vue';
import Shop from '../views/shop/Index.vue';
import NotFound from '../views/NotFound.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/news',
    name: 'ArchiveNews',
    component: ArchiveNews,
  },
  {
    path: '/news/:slug',
    name: 'SingleNews',
    component: SingleNews,
  },
  {
    path: '/concept',
    name: 'Concept',
    component: Concept,
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
  },
  {
    path: '/:notFound(.*)',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
